import { FileWithPath, useDropzone } from "react-dropzone";
import { ReactNode, useCallback, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { AddImage } from "../../api/UploadImage/UploadImg";

const UploadProfile = ({
    folder,
    children,
    onFileUploaded,
    acceptedFiles = { "image/*": [] }
}: {
    folder: string;
    children: ReactNode,
    onFileUploaded: (fileName: string) => void,
    acceptedFiles?: { [fileType: string]: string[] }
}) => {
    const [uploadProgress, setUploadProgress] = useState(0); // State to track upload progress

    const { mutate } = useMutation({
        mutationFn: (formData: FormData) => AddImage(formData, folder, (event) => {
            // Cap the progress at 95% unless the upload is confirmed to be successful
            const progress = Math.round((event.loaded * 90) / event.total);
            setUploadProgress(progress);
        }),
        onSuccess: (response) => {
            if (response && response.url) {
                setUploadProgress(100);
                onFileUploaded(response.url);
            } else {
                setUploadProgress(0);
            }
        },
        onError: () => {
            setUploadProgress(0);
        }
    });
    const onDrop = useCallback((acceptedFiles: File[]) => {
        acceptedFiles.map((file: FileWithPath) => {
            const reader = new FileReader();
            reader.onload = () => {
                const formData = new FormData();
                formData.append("file", file);
                mutate(formData);
                onFileUploaded(file.name);
            };
            reader.readAsArrayBuffer(file);
        });
    }, [mutate, onFileUploaded]);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: acceptedFiles,
    });

    return (
        <div>
            <div {...getRootProps({ className: "dropzone" })}>
                <input {...getInputProps()} />
                {children}
            </div>
            {uploadProgress > 0 && (
                <div style={{ width: '100%' }}>
                    <div className="bg-[#4379EE] h-2" style={{ width: `${uploadProgress}%` }}>
                    </div>
                </div>
            )}
        </div>
    )
}

export default UploadProfile